<div class="m-4 form-scroll" [class.disabledForm]="disabledForm()">
  <form-builder
    [form]="initialForm()"
    (change)="handleChangeClick($event)"
    [options]="formIoConfiguration"
  ></form-builder>
</div>
